import { Option } from '@bringg/react-components/dist/components/filter-bar';

import type Team from 'bringg-web/stores/teams/domain-object/team';
import TeamsStore from 'bringg-web/stores/teams/teams-store';

export const mapItemsToFilter = (storeItems: Option<number>[]) =>
	storeItems.map(item => ({
		label: item.name,
		value: item.id
	}));

export const mapTeamToFilter = (teams: Team[], teamsStore: TeamsStore) =>
	teams.map(item => ({
		label: item.name,
		value: item.id,
		children: item.childrenTeamIds.length
			? mapItemsToFilter(item.childrenTeamIds.map(id => teamsStore.get(id)))
			: []
	}));
